<template>
  <div class="organization" v-bind:class="meBan">
    <li v-if="!tree['default'] && tree['groupName']" class="fl-between" @click.self="onClickOrganization(tree.groupId)">
      <span class="group-name organization-name" v-bind:style="depthBlank">
        <span v-if="tree['children'] && !tree['childInactive']" @click="openCheck()">
        <button v-bind:class="meBan" class="btn mark btn-secondary">
          <i :class="{'chevronUp' : check}" class="fa fa-chevron-down" ></i>
        </button>
        </span>
        <span v-else class="btn mark nonemark">
        </span>
      <span @click.self="onClickOrganization(tree['groupId'])">{{ tree['groupName'] }}</span>
      <span v-if="checkedOrganization!=='' && checkedOrganization===tree['groupId'] ||
       checkedOrganizations[0] !=='default' && checkedOrganizations.includes(tree['groupId'])" >
        <span class="check-mark"></span>
      </span>
    </span>
      <span class="group-info" v-bind:class="meBan_text">{{$t('memberStr')}}:
        <span class="menber-count">({{ Object.keys(tree.members || {}).length }})</span>
        <span class="group-edit" v-if="editAble">
          <manage-group-drop-down :tag="tag" :item="getOrganizationObject" :id="tree['groupId']"/>
        </span>
      </span>
    </li>
    <li v-else-if="noneSelect && parentSelect && depth === -1" class="fl-between" @click.self="onClickOrganization('root')">
      <span class="group-name organization-name" v-bind:style="depthBlank">
        <span v-if="tree['children']" >
        <button class="btn mark btn-secondary">
        <i :class="{'chevronUp' : check}" class="fa fa-chevron-down" @click.self="openCheck()"></i>
        </button>
        </span>
        <span v-else class="btn mark nonemark">
        </span>
      <span class="none-select" @click.self="onClickOrganization('root')">{{ $t('noneSelectStr') }}</span>
      <span v-if="checkedOrganization!=='' && checkedOrganization==='root' ||
      !checkedOrganizations[0]==='default' && checkedOrganizations.includes('root')" >
        <span class="check-mark"></span>
      </span>
    </span>
    </li>
    <template v-for="child of getChildTree">
      <transition name="childTree" :key="child['groupId']">
        <organization-item
          v-if="(getChildTree.length > 0 && !child['isInactive'] &&　getchecker) || rootException && !child['isInactive']"
          :parentSelect="parentSelect"
          :editAble="editAble"
          :noneSelect="noneSelect"
          :checkedOrganization="checkedOrganization"
          :checkedOrganizations="checkedOrganizations"
          :OrganizaitonPath="OrganizaitonPath"
          :outputOrganization="outputOrganization"
          :depth="depth+1"
          :tree="child"
          :bans="bans"
          :organizationOpens="returnOpens"
          @onClickOrganization="$emit('onClickOrganization', $event)">
        </organization-item>
      </transition>
    </template>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import ManageGroupDropDown from '@/components/Manage/ManageGroupDropDown'
import OrganizationItem from '@/components/People/OrganizationItem'
export default {
  name: 'OrganizationItem',
  components: {
    ManageGroupDropDown,
    OrganizationItem
  },
  props: {
    SearchOrganization: {
      type: Boolean,
      default: false
    },
    RootOrganizationIds: {
      type: Array,
      default: () => (['default'])
    },
    OrganizaitonPath: {
      // Search後の開閉処理,parent->organizationの表示など
      type: Object,
      default: () => ({default: true})
    },
    noneSelect: {
      type: Boolean,
      default: true
    },
    parentSelect: {
      type: Boolean,
      default: false
    },
    checkedOrganization: {
      type: String,
      default: ''
    },
    bans: {
      type: Array,
      default: () => (['default'])
    },
    checkedOrganizations: {
      type: Array,
      default: () => (['default'])
    },
    depth: {
      type: Number,
      default: -1
    },
    tree: {
      type: Object,
      default: () => ({default: true})
    },
    bindSelectedByParent: {
      type: Boolean,
      default: false
    },
    editAble: {
      type: Boolean,
      default: true
    },
    organizationOpens: {
      type: Array,
      default: () => (['default'])
    },
    userVisibleOrganization: {
      type: Boolean,
      default: false
    },
    outputOrganization: {
      type: Object,
      default: () => ({default: true})
    }
  },
  data () {
    return {
      tag: 'OrganizationItem',
      removeTarget: {
        id: '',
        target: ''
      },
      openOrganization: { },
      openOrganizations: [],
      check: false,
      haveTree: {},
      rootInfo: { groupName: '', members: {} },
      opens: [],
      rootChecker: false,
      clickChecker: false
    }
  },
  beforeDestroy: function () {
    this.check = false
    this.opens = []
    this.rootChecker = false
    this.haveTree = {}
  },
  mounted: function () {
    if (this.tree['default']) {
      this.haveTree = this.createdRootTree
      this.check = true
    } else {
      this.haveTree = this.tree
    }
    let pathIndex = -1
    if (this.OrganizaitonPath.hasOwnProperty('node')) {
      pathIndex = this.OrganizaitonPath['node'].indexOf(this.tree['groupId']) || -1
    }
    if (pathIndex >= 0) {
      this.OrganizaitonPath['node'].splice(pathIndex, 1)
      this.opens.push(this.tree['groupId'])
    } else if (!this.tree['default'] && !this.clickChecker) {
      this.check = false
    }
    if (this.OrganizaitonPath.hasOwnProperty('child') && this.OrganizaitonPath['roots']) {

    }
  },
  computed: {
    ...mapGetters('groups/', [
      'getGroupById',
      'getGroupsByIds',
      'getGroups'
    ]),
    ...mapGetters('organizations/', [
      'getOnlyOrganizationsByText',
      'getOnlyOrganizationsById',
      'getOnlyOrganizationsByIds'
    ]),
    getOrganizationObject: function () {
      return this.getGroupById(this.tree['groupId'])
    },
    meBan: function () {
      if (this.bans.includes(this.tree.groupId)) {
        return 'bg-secondary'
      }
    },
    meBan_text: function () {
      if (this.bans.includes(this.tree.groupId)) {
        return 'text-light'
      }
    },
    returnOpens: function () {
      return this.organizationOpens.concat(this.opens)
    },
    rootException: function () {
      if (!this.clickChecker && this.OrganizaitonPath && this.OrganizaitonPath['roots'] && this.OrganizaitonPath.hasOwnProperty('node') &&
      this.OrganizaitonPath['roots'].includes(this.tree['groupId']) && this.OrganizaitonPath['node'].includes(this.tree['groupId'])) {
        this.check = true
        return this.check
      }
      return false
    },
    getchecker: function () {
      if (this.OrganizaitonPath.hasOwnProperty('node') && this.OrganizaitonPath['node'].includes(this.tree['groupId']) && !this.rootChecker && !this.clickChecker) {
        this.check = true
        this.rootChecker = true
      }
      if (this.OrganizaitonPath.hasOwnProperty('default') && !this.clickChecker && this.depth >= 0) {
        this.check = false
        this.rootChecker = true
      }
      // console.log('what is organization:', this.getOrganizationObject, this.tree['groupId'], this.tree['groupName'], this.check, this.clickChecker, this.OrganizaitonPath['node'])
      return this.check
    },
    Opencheck: function () {
      return this.check || this.tree['OrganizaitonPath']
    },
    getOnlyOrganizationsInfo: function () {
      let organizations = this.getOnlyOrganizationsByIds(Object.keys(this.getGroups))['node']
      // return this.getGroupsByIds(Object.keys(this.getGroups))
      return organizations
    },
    getGroupas: function () {
      return Object.keys(this.getGroups)
    },
    getChildren: function () {
      if (this.getOrganizationObject.childGroups) {
        return Object.keys(this.getOrganizationObject.childGroups)
      } else {
        return 'none'
      }
    },
    getChildTree: function () {
      let haveTree = {}
      if (this.tree['default']) {
        haveTree = this.createdRootTree
        haveTree['check'] = true
      } else {
        haveTree = Object.assign(haveTree, this.tree)
      }
      if (haveTree && haveTree.hasOwnProperty('children')) {
        return haveTree['children']
      }
    },
    depthBlank: function () {
      let blanksize = String(this.depth * 30) + 'px'
      let depth = {}
      depth['margin-left'] = blanksize
      return depth
    },
    createdRootTree: function () {
      let items = {}
      items['children'] = []
      if (this.OrganizaitonPath.hasOwnProperty('default') || this.userVisibleOrganization) {
        let organizationRootIds = Object.keys(this.getOnlyOrganizationsByIds(Object.keys(this.getGroups))['root'])
        for (let child of organizationRootIds) {
          items['children'].push(this.createTree(child))
        }
      }
      if (!this.OrganizaitonPath.hasOwnProperty('default') && !this.userVisibleOrganization) {
        for (let child of this.OrganizaitonPath['roots']) {
          items['children'].push(this.createTree(child))
        }
      }
      console.log('Tree:', items)
      return items
    }
  },
  methods: {
    onClickOrganization: function (groupId) {
      if (!!groupId && groupId.length > 0 && !this.bans.includes(groupId)) {
        this.$emit('onClickOrganization', groupId)
      }
    },
    openCheck: function () {
      if (this.tree.hasOwnProperty('openChild')) {
        this.tree['openChild'] = false
      }
      this.clickChecker = true
      this.check = !this.check
    },
    createTree: function (rootOrganizationId) {
      let organization = {}
      let organizationInfo = this.getGroupById(rootOrganizationId)
      organization['groupId'] = rootOrganizationId
      organization['groupName'] = organizationInfo['groupName']
      organization['members'] = organizationInfo['members']
      if (organizationInfo && organizationInfo.hasOwnProperty('isInactive')) {
        organization['isInactive'] = organizationInfo['isInactive']
      }
      if (organizationInfo && organizationInfo.hasOwnProperty('childGroups')) {
        let childGroups = Object.keys(this.getGroupById(rootOrganizationId)['childGroups'])
        organization['children'] = []
        let childActive = false
        for (let child of childGroups) {
          let tree = this.createTree(child)
          organization['children'].push(tree)
          if (!childActive && !tree['isInactive']) {
            childActive = true
          }
        }
        if (!childActive) {
          organization['childInactive'] = true
        }
        // .forEach((value, i) => { organization['children'].push(this.createTree(value)) })
        // [objectkey1, objectkey2, objectkey3, ...]
      }
      return organization
    },
    getChildOrganization: function (childGroups) {
      let organizations = this.getOnlyOrganizationsByIds(Object.keys(childGroups))['node']
      return organizations
    }
  }
}
</script>
<style scoped>
 .nonemark {
   margin-right: 11.3px;
 }
 .none-select {
   margin-left: 30px;
 }
 .organization {
   width: 100%;
 }
 .organization li {
   margin-bottom: 0.7em;
   padding-bottom: 0.5em;
   border-bottom: 1px solid #e7eaec;
   display: flex;
 }
 .mark {
    top: -0.5rem;
    left: -0.7rem;
    display: inline-block;
 }
 .organization-name {
   margin-left:-0.5rem;
 }
 .check-mark {
   content: " ";
   z-index: 10;
   display: table-caption;
   height: 3rem;
   width: 3rem;
   border-radius: 50%;
   background-image: url("../../../static/img/assets/success.png");
   background-position: center;
   background-size: 100%;
   position: relative;
   left: 0;
   top: 1.2rem;
 }

.btn.mark>i {
  transition: transform 0.4s;
}
 .chevronUp {
   transform: rotate(180deg);
 }
 .childTree-enter-active {
   transition: all 0.4s;
   height: 47px;
 }
 .childTree-enter {
  transition: all 0.4s;
  height: 0;
  opacity: 0;
 }
 .childTree-leave-active {
   transition:  all 0.4s;
   height: 0px;
   opacity: 0;
 }
 .childTree-leave {
   transition: all 0.4s;
   height: 47px;
   opacity: 0;
 }
</style>



// WEBPACK FOOTER //
// src/components/People/OrganizationItem.vue